import React, { useState } from "react";
import ReactDOM from "react-dom";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import GatePassForm from "./components/GatePassForm";
import GatePassList from "./components/GatePassList";
import TodaysData from "./components/TodaysData";
import LoginForm from "./components/LoginForm";
import PromoBanner from "./components/PromoBanner";
import Header from "./components/Header";

import { LanguageProvider } from "./context/LanguageContext";
import { ToastProvider } from "./context/ToastContext";

const Layout = ({ authenticated, setAuthenticated }) => {
  return (
    <>
      {authenticated && <Header setAuthenticated={setAuthenticated} />}
      <Outlet />
    </>
  );
};

const App = () => {
  const [authenticated, setAuthenticated] = useState(false);

  const router = createBrowserRouter([
    {
      element: <Layout authenticated={authenticated} setAuthenticated={setAuthenticated} />,
      children: [
        {
          path: "/",
          element: authenticated ? (
            <GatePassForm />
          ) : (
            <LoginForm setAuthenticated={setAuthenticated} />
          ),
        },
        {
          path: "/gatepasslist",
          element: authenticated ? (
            <GatePassList />
          ) : (
            <LoginForm setAuthenticated={setAuthenticated} />
          ),
        },
      ],
    },
    {
      path: "/todays-gatepassdata",
      element: <TodaysData />
    },
  ]);

  return (
    <>
      <PromoBanner />
      <RouterProvider router={router} />
    </>
  );
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <LanguageProvider>
    <ToastProvider>
      <App />
    </ToastProvider>
  </LanguageProvider>
);
